<script setup lang="ts">
const isDesktop = computed(() =>
  useNuxtApp().$viewport.isGreaterOrEquals('desktop'),
);

const props = withDefaults(
  defineProps<{
    colSpan?: number;
    rowSpan?: number;
    colStart?: number | 'auto';
    rowStart?: number | 'auto';
    forcePosition?: boolean;
    noBorderBottom?: boolean;
    noBorderRight?: boolean;
    borderColor?: string;
  }>(),
  {
    colStart: 'auto',
    rowStart: 'auto',
    colSpan: 1,
    rowSpan: 1,
    borderColor: '',
  },
);
</script>

<template>
  <div
    :class="[
      $style.item,
      { [$style.item_noBorderRight!]: noBorderRight },
      { [$style.item_noBorderBottom!]: noBorderBottom },
      { [$style.item_col3!]: isDesktop && props.colSpan === 3 },
      { [$style.item_col2!]: isDesktop && props.colSpan === 2 },
      { [$style.item_col1!]: isDesktop && props.colSpan === 1 },
    ]"
    :style="{
      gridRow: `span ${rowSpan || 1}`,
      gridColumn: `span ${rowSpan || 1}`,
      borderColor: borderColor || undefined,
      gridColumnStart:
        isDesktop || props.forcePosition ? props.colStart : 'auto',
      gridRowStart: isDesktop || props.forcePosition ? props.rowStart : 'auto',
      gridColumnEnd: `span ${props.colSpan}`,
      gridRowEnd: `span ${props.rowSpan}`,
    }"
  >
    <slot />
  </div>
</template>

<style module lang="scss">
.item {
  border-bottom: 1px solid var(--color-gray-line);
  border-right: 1px solid var(--color-gray-line);
  overflow: hidden;

  &_noBorderRight {
    border-right: none;
  }
  &_noBorderBottom {
    border-bottom: none;
  }

  &_col1 {
    grid-column: span 1;
  }
  &_col2 {
    grid-column: span 2;
  }
  &_col3 {
    grid-column: span 3;
  }
}

// 2 колонки максимум
@media (min-width: 768px) and (max-width: 1379px) {
  .item {
    &_col3 {
      grid-column: span 2;
    }
  }
}

// 1 колонка максимум
@media (max-width: 767px) {
  .item {
    &_col1 {
      grid-column: span 1;
    }
    &_col2 {
      grid-column: span 1;
    }
    &_col3 {
      grid-column: span 1;
    }
  }
}
</style>
